// to install jwt decode use this command: yarn add jwt-decode@3.1.2

import jwtDecode from 'jwt-decode';

export class JwtHelper {

    public static decodeToken<T>(token: string): T {

        if (!token) {
            console.warn('Token is not provided or is empty');
            return {} as T;
        }

        try {
            return jwtDecode<T>(token);
        } catch (e) {
            console.error('Failed to decode token:', e);
            return {} as T;
        }
    }

    public static getTokenExpirationDate(token: string): Date | null {
        const decoded = this.decodeToken<Partial<{ exp: number }>>(token);

        if (!decoded.hasOwnProperty('exp')) {
            return null;
        }

        const date = new Date(0);
        date.setUTCSeconds(decoded.exp);

        return date;
    }

    public static isTokenExpiringSoon(token: string, offsetSeconds?: number): boolean {
        if (token === null || token === '') {
            return true;
        }
        const date = this.getTokenExpirationDate(token);
        offsetSeconds = offsetSeconds || 0;

        if (date === null) {
            return true;
        }

        return !(date.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }

    public static isTokenExpired(token: string): boolean {
        const date = this.getTokenExpirationDate(token);
        if (date === null) {
            return true;
        }
        return !(date.valueOf() > new Date().valueOf());
    }

    public static isValidJWT(token: string): boolean {
        const jwtRegex = /^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*$/;
        return jwtRegex.test(token);
    }
}
